import { TooltipDirection } from './Tolltip.enum';
const handleTooltipPosition = (tooltipDirection) => {
    switch (tooltipDirection) {
        case TooltipDirection.UP_MID:
        default:
            return `
        bottom: 35px;
        left: 50%;
        transform: translateX(-50%);
    `;
        case TooltipDirection.UP_RIGHT:
            return `
        bottom: 35px;
        left: 0px;
    `;
        case TooltipDirection.UP_LEFT:
            return `
        bottom: 35px;
        right: 0px;
    `;
        case TooltipDirection.DOWN_MID:
            return `
        top: 30px;
        left: 50%;
        transform: translateX(-50%);
    `;
        case TooltipDirection.DOWN_LEFT:
            return `
        top: 30px;
        right: 0px;
    `;
        case TooltipDirection.DOWN_RIGHT:
            return `
        top: 30px;
        left: 0px;
    `;
        case TooltipDirection.LEFT_MID:
            return `
        top: 50%;
        right: 30px;
        transform: translateY(-50%);
    `;
        case TooltipDirection.LEFT_DOWN:
            return `
        top: 3px;
        right: 30px;
    `;
        case TooltipDirection.LEFT_UP:
            return `
        bottom: 6px;
        right: 30px;
    `;
        case TooltipDirection.RIGHT_MID:
            return `
        top: 50%;
        left: 30px;
        transform: translateY(-50%);
    `;
        case TooltipDirection.RIGHT_UP:
            return `
        bottom: 6px;
        left: 30px;
    `;
        case TooltipDirection.RIGHT_DOWN:
            return `
        top: 3px;
        left: 30px;
    `;
    }
};
const handleTooltipArrowPosition = (tooltipDirection) => {
    switch (tooltipDirection) {
        case TooltipDirection.UP_MID:
        default:
            return `
        bottom: -2px;
        left: 50%;
    `;
        case TooltipDirection.UP_RIGHT:
            return `
        bottom: -2px;
        left: 10px;
    `;
        case TooltipDirection.UP_LEFT:
            return `
        bottom: -2px;
        right: -1px;
    `;
        case TooltipDirection.DOWN_MID:
            return `
        top: -2px;
        left: 50%;
    `;
        case TooltipDirection.DOWN_LEFT:
            return `
        top: -2px;
        right: -1px;
    `;
        case TooltipDirection.DOWN_RIGHT:
            return `
        top: -2px;
        left: 10px;
    `;
        case TooltipDirection.LEFT_MID:
            return `
        right: -2px;
        top: 50%;
        transform: translateY(-50%) rotate(45deg);
    `;
        case TooltipDirection.LEFT_DOWN:
            return `
        top: 3px;
        right: -7px;
    `;
        case TooltipDirection.LEFT_UP:
            return `
        bottom: 3px;   
        right: -7px;
    `;
        case TooltipDirection.RIGHT_MID:
            return `
        left: -2px;
        top: 50%;
        transform: translateY(-50%) rotate(45deg);
    `;
        case TooltipDirection.RIGHT_UP:
            return `
        bottom: 3px;
        left: 4px;
    `;
        case TooltipDirection.RIGHT_DOWN:
            return `
        top: 3px;
        left: 4px;
    `;
    }
};
export { handleTooltipArrowPosition, handleTooltipPosition };
//# sourceMappingURL=Tooltip.helpers.js.map